export default "__VITE_ASSET__CCk5Iv83__"